import PropTypes from 'prop-types';
import React from 'react';
import Image from 'next/image';
import Heading from '../../Typography/Heading';
import BodyContent from '../../BodyContent/BodyContent';
import EmbeddedContentStyles from './EmbeddedContent.styled';
import EmbeddedVideo from './EmbeddedVideo';

const EmbeddedContent = ({ embeddedContent }) => {
  return (
    <EmbeddedContentStyles>
      {/* all types of embedded content could have any combination of header, subheader and long intro */}
      {embeddedContent.embeddedContentHeader ? (
        <p className="embedded-content-headline">
          {embeddedContent.embeddedContentHeader}
        </p>
      ) : null}
      {embeddedContent.embeddedContentSubHeader ? (
        <p className="embedded-content-sub-headline">
          {embeddedContent.embeddedContentSubHeader}
        </p>
      ) : null}
      {embeddedContent.embeddedContentLongIntro ? (
        <BodyContent markdown={embeddedContent.embeddedContentLongIntro} />
      ) : null}

      {embeddedContent.mediaType === 'Video' ? (
        <EmbeddedVideo
          videoSource={embeddedContent.videoSource}
          childMarkdownRemark={embeddedContent.embeddedContent}
        />
      ) : null}

      {/* If the media type is List, create an iframe with the embedded content  */}
      {embeddedContent.mediaType === 'List' ? (
        <iframe
          src={embeddedContent.embeddedContent}
          height="700"
          width="100%"
        />
      ) : null}
      {embeddedContent.mediaType === 'Quiz' ? (
        <iframe
          src={embeddedContent.embeddedContent}
          height="600"
          width="100%"
        />
      ) : null}

      {/* Show embedded body copy if they've provided it  */}
      {embeddedContent.bodyCopyHeader ? (
        <Heading headingSize="medium" headingTag="h3">
          {embeddedContent.bodyCopyHeader}
        </Heading>
      ) : null}
      {embeddedContent.bcMedia &&
      embeddedContent.bcMedia.file &&
      embeddedContent.bcMedia.file.url ? (
        <Image src={embeddedContent.bcMedia.file.url + '?w=800'} fill />
      ) : null}
      {embeddedContent.bodyText ? (
        <BodyContent markdown={embeddedContent.bodyText} />
      ) : null}
    </EmbeddedContentStyles>
  );
};

EmbeddedContent.propTypes = {
  embeddedContent: PropTypes.shape({
    bcMedia: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
    bodyCopyHeader: PropTypes.any,
    bodyText: PropTypes.any,
    embeddedContent: PropTypes.any,
    embeddedContentHeader: PropTypes.any,
    embeddedContentLongIntro: PropTypes.any,
    embeddedContentSubHeader: PropTypes.any,
    mediaType: PropTypes.string,
    videoSource: PropTypes.any,
  }),
};

export default EmbeddedContent;
